var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.useraccess.length > 0
    ? _c(
        "div",
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isLoggedInUserActive,
                      expression: "!isLoggedInUserActive"
                    }
                  ]
                },
                [
                  _c("label", { staticStyle: { color: "red" } }, [
                    _vm._v(_vm._s(_vm.$t("msguserisnotactive")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("v-data-table", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLoggedInUserActive,
                    expression: "isLoggedInUserActive"
                  }
                ],
                attrs: {
                  headers: _vm.headers,
                  items: _vm.headcount,
                  search: _vm.search,
                  "footer-props": {
                    itemsPerPageOptions: _vm.tableItemsPerPage,
                    itemsPerPageText: _vm.rowsperpage
                  },
                  options: _vm.options
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "top",
                      fn: function() {
                        return [
                          _c(
                            "v-dialog",
                            {
                              attrs: { "max-width": "500px" },
                              model: {
                                value: _vm.dialogDelete,
                                callback: function($$v) {
                                  _vm.dialogDelete = $$v
                                },
                                expression: "dialogDelete"
                              }
                            },
                            [
                              _c(
                                "v-card",
                                { attrs: { light: "", flat: "" } },
                                [
                                  _c(
                                    "v-card-title",
                                    { staticClass: "headline" },
                                    [
                                      _vm._v(
                                        "Are you sure you want to delete this item?"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c("v-progress-circular", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.deleteinProgress,
                                            expression: "deleteinProgress"
                                          }
                                        ],
                                        attrs: {
                                          indeterminate: "",
                                          color: "primary"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.deleteinProgress,
                                              expression: "!deleteinProgress"
                                            }
                                          ],
                                          attrs: {
                                            color: "blue darken-1",
                                            text: ""
                                          },
                                          on: { click: _vm.closeDelete }
                                        },
                                        [_vm._v("Close")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.deleteinProgress,
                                              expression: "!deleteinProgress"
                                            }
                                          ],
                                          attrs: {
                                            color: "blue darken-1",
                                            text: ""
                                          },
                                          on: { click: _vm.deleteItemConfirm }
                                        },
                                        [_vm._v("OK")]
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer")
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-toolbar",
                            { attrs: { flat: "", dense: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary", dark: "" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.openNewEditForm()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("new")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-dialog",
                                {
                                  attrs: { "max-width": "500px" },
                                  model: {
                                    value: _vm.dialog,
                                    callback: function($$v) {
                                      _vm.dialog = $$v
                                    },
                                    expression: "dialog"
                                  }
                                },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-title",
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "headline" },
                                            [_vm._v(_vm._s(_vm.formTitle))]
                                          ),
                                          _vm._v(" "),
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.close(1)
                                                }
                                              }
                                            },
                                            [_vm._v("close")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-container",
                                            [
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "8",
                                                        md: "4"
                                                      }
                                                    },
                                                    [
                                                      _c("v-select", {
                                                        staticStyle: {
                                                          "background-color":
                                                            "#ffffcc"
                                                        },
                                                        attrs: {
                                                          items: _vm.plants,
                                                          label: _vm.$t(
                                                            "plant"
                                                          ),
                                                          "item-text": "plant",
                                                          "item-value": "id",
                                                          disabled:
                                                            _vm.editedIndex > -1
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.changePlant
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.selecttedplant,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.selecttedplant = $$v
                                                          },
                                                          expression:
                                                            "selecttedplant"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "8",
                                                        md: "4"
                                                      }
                                                    },
                                                    [
                                                      _c("v-select", {
                                                        staticStyle: {
                                                          "background-color":
                                                            "#ffffcc"
                                                        },
                                                        attrs: {
                                                          items: _vm.companies,
                                                          label: _vm.$t(
                                                            "company"
                                                          ),
                                                          "item-text": "value",
                                                          "item-value": "id",
                                                          disabled:
                                                            _vm.editedIndex > -1
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.selectedcontractor,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.selectedcontractor = $$v
                                                          },
                                                          expression:
                                                            "selectedcontractor"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "8",
                                                        md: "4"
                                                      }
                                                    },
                                                    [
                                                      _c("v-select", {
                                                        staticStyle: {
                                                          "background-color":
                                                            "#ffffcc"
                                                        },
                                                        attrs: {
                                                          items: _vm.maint_grp,
                                                          label: _vm.$t(
                                                            "maintgrp"
                                                          ),
                                                          "item-text": "value",
                                                          "item-value": "id",
                                                          disabled:
                                                            _vm.editedIndex > -1
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.selectedmaintgrp,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.selectedmaintgrp = $$v
                                                          },
                                                          expression:
                                                            "selectedmaintgrp"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                        md: "4"
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: _vm.$t("capex")
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .capex,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "capex",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.capex"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                        md: "4"
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "dailybusiness"
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .dailyBusiness,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "dailyBusiness",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.dailyBusiness"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                        md: "4"
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "overheads"
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .overheads,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "overheads",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.overheads"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                        md: "4"
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "others"
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.editedItem
                                                              .others,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.editedItem,
                                                              "others",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "editedItem.others"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                        md: "4"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-menu",
                                                        {
                                                          ref: "menu",
                                                          attrs: {
                                                            "close-on-content-click": false,
                                                            transition:
                                                              "scale-transition",
                                                            "offset-y": "",
                                                            "min-width": "290px"
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  ref
                                                                ) {
                                                                  var on =
                                                                    ref.on
                                                                  var attrs =
                                                                    ref.attrs
                                                                  return [
                                                                    _vm.dateFormat ==
                                                                      null ||
                                                                    _vm.dateFormat ===
                                                                      "mm/dd/yyyy"
                                                                      ? _c(
                                                                          "div",
                                                                          [
                                                                            _c(
                                                                              "v-text-field",
                                                                              _vm._g(
                                                                                _vm._b(
                                                                                  {
                                                                                    attrs: {
                                                                                      disabled:
                                                                                        _vm.editedIndex >
                                                                                        -1,
                                                                                      label: _vm.$t(
                                                                                        "infodate"
                                                                                      ),
                                                                                      hint:
                                                                                        "MM/DD/YYYY format",
                                                                                      "persistent-hint":
                                                                                        "",
                                                                                      "prepend-icon":
                                                                                        "event",
                                                                                      readonly:
                                                                                        ""
                                                                                    },
                                                                                    on: {
                                                                                      blur: function(
                                                                                        $event
                                                                                      ) {
                                                                                        _vm.date = _vm.parseDate(
                                                                                          _vm.dateFormatted
                                                                                        )
                                                                                      }
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        _vm.dateFormatted,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.dateFormatted = $$v
                                                                                      },
                                                                                      expression:
                                                                                        "dateFormatted"
                                                                                    }
                                                                                  },
                                                                                  "v-text-field",
                                                                                  attrs,
                                                                                  false
                                                                                ),
                                                                                on
                                                                              )
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    _vm.dateFormat ===
                                                                    "dd/mm/yyyy"
                                                                      ? _c(
                                                                          "div",
                                                                          [
                                                                            _c(
                                                                              "v-text-field",
                                                                              _vm._g(
                                                                                _vm._b(
                                                                                  {
                                                                                    attrs: {
                                                                                      disabled:
                                                                                        _vm.editedIndex >
                                                                                        -1,
                                                                                      label: _vm.$t(
                                                                                        "infodate"
                                                                                      ),
                                                                                      hint:
                                                                                        "DD/MM/YYYY Format",
                                                                                      "persistent-hint":
                                                                                        "",
                                                                                      "prepend-icon":
                                                                                        "event",
                                                                                      readonly:
                                                                                        ""
                                                                                    },
                                                                                    on: {
                                                                                      blur: function(
                                                                                        $event
                                                                                      ) {
                                                                                        _vm.date = _vm.parseDate(
                                                                                          _vm.dateFormatted
                                                                                        )
                                                                                      }
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        _vm.dateFormatted,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.dateFormatted = $$v
                                                                                      },
                                                                                      expression:
                                                                                        "dateFormatted"
                                                                                    }
                                                                                  },
                                                                                  "v-text-field",
                                                                                  attrs,
                                                                                  false
                                                                                ),
                                                                                on
                                                                              )
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            false,
                                                            838132285
                                                          ),
                                                          model: {
                                                            value: _vm.menu,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.menu = $$v
                                                            },
                                                            expression: "menu"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-date-picker",
                                                            {
                                                              attrs: {
                                                                "no-title": "",
                                                                scrollable: ""
                                                              },
                                                              model: {
                                                                value: _vm.date,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.date = $$v
                                                                },
                                                                expression:
                                                                  "date"
                                                              }
                                                            },
                                                            [
                                                              _c("v-spacer"),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    text: "",
                                                                    color:
                                                                      "primary"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.menu = false
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Cancel"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    text: "",
                                                                    color:
                                                                      "primary"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.$refs.menu.save(
                                                                        _vm.date
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("OK")]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-actions",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !_vm.saveInProgress,
                                                  expression: "!saveInProgress"
                                                }
                                              ],
                                              attrs: {
                                                color: "blue darken-1",
                                                text: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.close(1)
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(_vm.$t("cancel")))]
                                          ),
                                          _vm._v(" "),
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c("v-progress-circular", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.saveInProgress,
                                                expression: "saveInProgress"
                                              }
                                            ],
                                            attrs: {
                                              indeterminate: "",
                                              color: "primary"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !_vm.saveInProgress,
                                                  expression: "!saveInProgress"
                                                }
                                              ],
                                              staticClass: "mb-2",
                                              attrs: {
                                                color: "primary",
                                                dark: ""
                                              },
                                              on: { click: _vm.save }
                                            },
                                            [_vm._v(_vm._s(_vm.$t("save")))]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider", {
                                staticClass: "mx-4",
                                attrs: { inset: "", vertical: "" }
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "white--text",
                                  attrs: { color: "blue-grey" },
                                  on: { click: _vm.exportexcel }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.$t("export")) +
                                      "\n                        "
                                  ),
                                  _c(
                                    "v-icon",
                                    { attrs: { right: "", dark: "" } },
                                    [_vm._v("arrow_downward")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider", {
                                staticClass: "mx-4",
                                attrs: { inset: "", vertical: "" }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "mdi-magnify",
                                  label: _vm.$t("searchall"),
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                model: {
                                  value: _vm.search,
                                  callback: function($$v) {
                                    _vm.search = $$v
                                  },
                                  expression: "search"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "item.action",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2",
                              attrs: { small: "" },
                              on: {
                                click: function($event) {
                                  return _vm.editItem(item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    mdi-pencil\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              attrs: { small: "" },
                              on: {
                                click: function($event) {
                                  return _vm.deleteItem(item)
                                }
                              }
                            },
                            [_vm._v(" mdi-delete ")]
                          )
                        ]
                      }
                    },
                    {
                      key: "no-data",
                      fn: function() {
                        return [
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: { click: _vm.getUser }
                            },
                            [_vm._v("Reset")]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        ],
        1
      )
    : _c(
        "div",
        [
          _c("v-progress-linear", {
            attrs: {
              indeterminate: "",
              color: "teal",
              rounded: "",
              height: "8"
            }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dc7cce2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dc7cce2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = null
// module chunks = 